import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseAvatarGroup = {
  avatarGroupMarginSmall: css`var(--cse-avatar-group-margin-small, calc(-1 * ${csSpacing.spacing05}))`,
  avatarGroupMarginMedium: css`var(--cse-avatar-group-margin-medium, calc(-1 * ${csSpacing.spacing05}))`,
  avatarGroupMarginLarge: css`var(--cse-avatar-group-margin-large, calc(-1 * ${csSpacing.spacing06}))`,
  avatarGroupMarginExtraLarge: css`var(--cse-avatar-group-margin-extra-large, calc(-1 * ${csSpacing.spacing07}))`,
}

export const style: CSSResult = css`
  .cse-avatar-group{
    display: flex;
    flex-direction: row;
  }
  .cse-avatar-group ::slotted(cse-avatar){
    transition: z-index 0.2s;
    box-sizing: content-box;
  }
  .cse-avatar-group ::slotted(cse-avatar:first-child) {
    margin-left: 0;
  }
  .cse-avatar-group ::slotted(cse-avatar[size="small"]) {
    margin-left: ${cseAvatarGroup.avatarGroupMarginSmall};
  }
  .cse-avatar-group ::slotted(cse-avatar[size="medium"]) {
    margin-left: ${cseAvatarGroup.avatarGroupMarginMedium};
  }
  .cse-avatar-group ::slotted(cse-avatar[size="large"]) {
    margin-left: ${cseAvatarGroup.avatarGroupMarginLarge};
  }
  .cse-avatar-group ::slotted(cse-avatar[size="extra-large"]) {
    margin-left: ${cseAvatarGroup.avatarGroupMarginExtraLarge};
  }
`
